var React = require('react');

function Figma (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z","fill":"#0acf83","key":0}),React.createElement("path",{"d":"M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z","fill":"#a259ff","key":1}),React.createElement("path",{"d":"M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z","fill":"#f24e1e","key":2}),React.createElement("path",{"d":"M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50z","fill":"#ff7262","key":3}),React.createElement("path",{"d":"M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z","fill":"#1abcfe","key":4})]);
}

Figma.defaultProps = {"viewBox":"0 0 200 300"};

module.exports = Figma;

Figma.default = Figma;
